import { render, staticRenderFns } from "./LiveRoomCallBackComment.vue?vue&type=template&id=cf7f69a4&scoped=true&"
import script from "./LiveRoomCallBackComment.vue?vue&type=script&lang=js&"
export * from "./LiveRoomCallBackComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7f69a4",
  null
  
)

export default component.exports